const isAxiosResponseError = error =>
  typeof error === "object" &&
  error !== null &&
  error instanceof Error &&
  "response" in error;

export default isAxiosResponseError;
